<template>
  <div
    class="bbp-number-cell"
    :ref="`bbp-number-cell_${row._id}`"
    @mouseleave="onMouseleave"
  >
    <span
      :class="[
       'bbp-number-cell_' + (column.className ? row.className : ''),
       isNoPaidDeleteInvoice && 'bbp-number-cell_red'
      ]"
    >
        {{value}}
    </span>
    <span
      v-if="icon && popupFileText"
      :class="[iconClassName && `bbp-number-cell${iconClassName}`]"
      v-html="icon()"
      @mouseenter="setShowInfo()"
    />
    <span
      v-if="isNoPaidDeleteInvoice"
      v-html="exclamationIcon()"
      :ref="`bbp-number-cell__icon-not-paid_${row._id}`"
      class="bbp-number-cell__icon-not-paid"
      @mouseenter="setShowInfoNotPaid"
      @mouseleave="onMouseleave"
    />
    <transition name="bbp-bounce">
      <div class="bbp-number-cell-popup" :style="positionInfo" v-if="showInfo && popupText">
        {{popupText}}
      </div>
    </transition>
    <transition name="bbp-fade">
      <BBPPopupsFile
        v-if="isPopupFile && showInfo && popupFileText"
        :position="positionInfo"
        :description="popupFileText"
        :row="row"
        :column="column"
        @onClickPopup="onClickPopup"
      />
    </transition>
    <transition
      v-if="showInfoPaid"
      name="bbp-fade"
      appear
    >
        <BBPPopupInfo
          text='The invoice has been deleted'
          :popupStyle="positionInfoPaid"
          :isRevert="true"
        />
    </transition>
  </div>
</template>

<script>
import {get} from 'lodash'
import convertNumber from '@/mixin/convertNumber'
import BBPPopupsFile from '@/components/Main/BBPPopups/BBPPopupsFile'
import BBPPopupInfo from '@/components/Main/BBPPopups/BBPPopupInfo'
import { EXCLAMATION_ICON } from '@/constants/icons'

export default {
  name: 'BBPNumberCell',
  components: {
    BBPPopupsFile,
    BBPPopupInfo
  },
  props: ['row', 'column', 'index'],
  mixins: [convertNumber],
  data () {
    return {
      showInfo: false,
      showInfoPaid: false,
      positionInfo: {},
      positionInfoPaid: {},
      exclamationIcon: EXCLAMATION_ICON
    }
  },
  computed: {
    value () {
      const number = get(this.row, this.column.prop, '')
      return this.convertNumber(number)
    },
    popupText () {
      const prop = get(this.column, 'popup', '')
      const value = get(this.row, prop, '')
      return value ? this.convertNumber(value) : ''
    },
    isPopupFile () {
      const { popupModal = {} } = this.column
      const { isShowFile } = popupModal
      return isShowFile
    },
    popupFileText () {
      const { popupModal = {} } = this.column
      const { prop } = popupModal
      const value = get(this.row, prop, '')
      return value
    },
    icon () {
      const { icon = {} } = this.column
      const { type } = icon
      return type
    },
    iconClassName () {
      const { icon = {} } = this.column
      const { className } = icon
      return className
    },
    isNoPaidDeleteInvoice () {
      const { statusProject } = this.column
      const { status, isRemoveInvoice = false } = this.row
      return (status === statusProject) && isRemoveInvoice
    }
  },
  methods: {
    onMouseleave () {
      this.showInfo = false
      this.showInfoPaid = false
      this.positionInfo = {}
    },
    onClickPopup () {
      const action = get(this.column, 'action', '')
      if (action && typeof action === 'function') action(this.row, this.column)
    },
    setShowInfo () {
      this.showInfo = true
      const { _id } = this.row
      const element = this.$refs[`bbp-number-cell_${_id}`]
      const position = element.getBoundingClientRect()
      const {height, top, left} = position
      this.positionInfo = {
        position: 'fixed',
        top: `${this.icon ? top + height : top + height + 8}px`,
        left: `${left}px`
      }
    },
    setShowInfoNotPaid () {
      this.showInfoPaid = true
      const { _id } = this.row
      const element = this.$refs[`bbp-number-cell__icon-not-paid_${_id}`]
      const { top, height, left, width } = element.getBoundingClientRect()

      this.positionInfoPaid = {
        position: 'fixed',
        top: `${top - height - 5}px`,
        left: `${left + (width / 2)}px`,
        textTransform: 'inherit'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-number-cell {
    @include global-font;
    position: relative;
    display: flex;
    align-items: center;

    &_red {
      margin-left: -7px;
      border-radius: 4px;
      padding: 10px 7px;
      color: $color-pomegranate;
      background-color: rgba($color-pomegranate, 0.2);
    }

    &__icon-article {
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background: $color-wild-sand;
      margin: 0 0 0 6px;
    }

    &__icon-not-paid {
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 0 0 6px;
    }

    &-popup {
      position: absolute;
      padding: 7px;
      background: rgba($color-black, 0.55);
      border-radius: 5px;
      color: $color-white;
      user-select: none;
      pointer-events: none;
      max-width: 60vw;

      &:before {
        content: '';
        position: absolute;
        left: auto;
        top: -3px;
        display: block;
        width: 0;
        height: 0;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        border-bottom: 3px solid rgba($color-black, 0.55);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPNumberCell/BBPNumberCell.vue